import { createAsyncThunk } from "@reduxjs/toolkit";

import { requestAliasScensum } from "../apiRequests/requestAliasScensum";

export const requestAlias = createAsyncThunk(
  "thunks/requestAlias",
  async (_, thunkAPI) => {
    const { apiConfigs } = thunkAPI.getState().requests;

    const response = await requestAliasScensum({
      apiConfigs,
      onSuccess: (response) => {
        return response;
      },
    });

    return response.data;
  }
);
